import { HTMLAttributes } from 'react'

import Tooltip from '@/ui/atoms/Tooltip'
import cn from '@/utils/tailwind/cn'

export type EditableBadgeRawItemProps = {
  color: string
} & HTMLAttributes<HTMLDivElement>

export const EditableBadgeRawItem = ({
  className,
  style,
  color,
  children,
  ...props
}: EditableBadgeRawItemProps) => {
  const totalLength = (children as string)?.length
  const showTooltip = totalLength > 11
  return (
    <Tooltip mouseEnterDelay={0.1} title={showTooltip ? children : undefined}>
      <div
        className={cn(
          'relative max-w-[100px] cursor-default overflow-hidden text-ellipsis whitespace-nowrap rounded-xl !border-transparent bg-gray-400 px-2.5 py-0.5 text-xs font-medium text-white [&:hover_.settings-badge]:flex',
          className
        )}
        style={{ background: color, ...style }}
        {...props}
      >
        {children}
      </div>
    </Tooltip>
  )
}
